<template>
  <b-form class="d-flex" @submit="onSubmit">
    <b-input-group
        class="filters-search d-sm-flex border-secondary "
        :class="{ 'focus': searchFocus }"
        size="sm"
    >
        <b-input-group-prepend class="align-items-center pl-2">
            <font-awesome-icon
                :icon="['fal', 'search']"
                class="text-primary"
                @focus="onSearchFocus"
                @blur="onSearchBlur"
            >
            </font-awesome-icon>
        </b-input-group-prepend>
        <b-form-input
            :placeholder="placeholder"
            @input="$emit('input', $event)"
            :value="value"
            @focus="onSearchFocus"
            @blur="onSearchBlur"
            ref="searchInput"
            class="bg-white rounded-0 border-0"
        ></b-form-input>
    </b-input-group>
    <slot></slot>
  </b-form>
</template>

<script>
export default {
  name: 'SearchFilter',
  props: {
    showSearch: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      default: 'Search',
    }
  },
  data() {
    return {
      searchFocus: false,
    };
  },
  methods: {
    onSearchFocus() {
      this.searchFocus = true;
      this.$refs.searchInput.$refs.input.focus();
    },
    onSearchBlur() {
      this.searchFocus = false;
    },
    onSubmit(e) {
      e.preventDefault();
      this.$emit('submit');
    }
  },
  watch: {
    showSearch: {
      handler: function () {
        this.$nextTick(() => {
          this.$refs.searchInput.$refs.input.focus();
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.filters-search {
    border: 1px solid $input-border-color;

    &.focus {
        box-shadow: $input-btn-focus-box-shadow;
        border-color: $input-focus-border-color !important;
    }

    input {
        @include hover-focus-active {
            box-shadow: none;
        }
    }
}
</style>
